import { styled } from 'styled-components';

import { colors, cssBreakpoints } from '#/theme/theme';

export const List = styled.ul`
  flex-wrap: wrap;
  list-style-type: none;
  padding-left: 0;
  color: ${colors.mediumContentGrey};

  li::before {
    content: '•';
    color: ${colors.brandBlue};
    display: inline-block;
    width: 1em;
  }
`;

export const BulletList_Box_1 = styled.li`
  width: 100%;

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    width: var(--w-md);
  }
`;
